import * as React from "react";
import { useResource, Resources } from "Translations/Resources";
import { SubMenu, SubMenuItem } from "Components/Shared/Menu/SubMenu";
import { isNoU } from "Utils/ObjectUtils";
import { EmployeeTypeCategoryID } from "Api/Api";
import {
  getEmployeeBaseUrl,
  getEmployeeEditRight,
} from "Components/HumanResources/Employees/EmployeeDetail/EmployeeDetailPage";

type Props = {
  employeeID: number;
  employeeTypeCategoryID: EmployeeTypeCategoryID;
};

export const EmployeesSideMenu: React.FunctionComponent<Props> = props => {
  const { employeeID } = props;
  const { t } = useResource();

  const menuItems = [
    {
      name: t(Resources.HumanResources.Employees.Detail.Title),
      url: `/${getEmployeeBaseUrl(t)}/${t(
        Resources.Routes.EmployeeDetail,
      )}/${employeeID}`,
    } as SubMenuItem<true>,
    {
      name: t(Resources.HumanResources.EmployeeEdit.Title),
      url: `/${getEmployeeBaseUrl(t)}/${t(
        Resources.Routes.EmployeeEdit,
      )}/${employeeID}`,
    } as SubMenuItem<true>,
  ];

  return (
    <>
      {!isNoU(employeeID) && (
        <SubMenu
          menuItems={menuItems}
          accessRight={[getEmployeeEditRight(props.employeeTypeCategoryID)]}
        />
      )}
    </>
  );
};
